export default "__VITE_ASSET__5I_fbDBD__"